var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSecurityIconInactive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.9985 1.66797C6.49202 1.66797 4.86681 3.35046 2.94476 3.96372C2.16323 4.21308 1.77247 4.33776 1.61433 4.51351C1.45619 4.68927 1.40988 4.94609 1.31726 5.45975C0.32619 10.9563 2.49241 16.0379 7.65857 18.0159C8.21365 18.2284 8.49119 18.3346 9.00123 18.3346C9.51127 18.3346 9.7888 18.2284 10.3438 18.0159C15.5097 16.0379 17.6738 10.9563 16.6825 5.45974C16.5898 4.946 16.5435 4.68913 16.3853 4.51337C16.2271 4.33762 15.8364 4.21301 15.0549 3.96379C13.1321 3.35059 11.5051 1.66797 8.9985 1.66797Z",
    stroke: "#6F7C8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 10.8333C6.5 10.8333 7.33333 10.8333 8.16667 12.5C8.16667 12.5 10.8137 8.33333 13.1667 7.5",
    stroke: "#6F7C8E",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSecurityIconInactive);
export default __webpack_public_path__ + "static/media/security-icon-inactive.f7b995663c68fba42aa3e29267c1e584.svg";
export { ForwardRef as ReactComponent };